module.exports = __webpack_public_path__ + "static/img/5.2c01564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-pt/5.jpg
// module id = 14Nq
// module chunks = 1